import { BRAND, whatsappLink } from "@/content/site";
import { Seo } from "@/components/Seo";

const H = ({ children }) => <h2 className="mt-12 mb-3 font-serif text-2xl md:text-3xl text-ink">{children}</h2>;

export default function Impressum() {
  return (
    <div data-testid="impressum-page">
      <Seo
        title="Impressum — WERKVERDUNG"
        description="Impressum und Anbieterkennzeichnung von WERKVERDUNG gemäß § 5 TMG."
        path="/impressum"
      />
      <section className="pt-36 md:pt-44 pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-bronze">— Impressum</span>
          <h1 className="mt-6 font-serif text-4xl md:text-6xl tracking-tight text-ink leading-[1.02]">
            Impressum
          </h1>

          <div className="mt-10 text-base text-stone leading-relaxed">
            <H>Angaben gemäß § 5 TMG</H>
            <address className="not-italic">
              {BRAND.owner}<br />
              WERKVERDUNG<br />
              {BRAND.address.street}<br />
              {BRAND.address.city}
            </address>

            <H>Kontakt</H>
            <p>
              E-Mail:{" "}
              <a href={`mailto:${BRAND.email}`} className="text-ink hover:text-bronze transition-colors">
                {BRAND.email}
              </a>
              <br />
              WhatsApp:{" "}
              <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" className="text-ink hover:text-bronze transition-colors">
                {BRAND.whatsappDisplay}
              </a>
            </p>

            <H>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</H>
            <address className="not-italic">
              {BRAND.owner}<br />
              {BRAND.address.street}<br />
              {BRAND.address.city}
            </address>

            <H>Haftung für Inhalte & Links</H>
            <p>
              Die Inhalte dieser Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
              Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Für
              Inhalte externer Links (z. B. zu Amazon, Gumroad) sind ausschließlich deren Betreiber
              verantwortlich.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
